<template>
<Dialog header="   " 
v-model:visible="$store.state.evaluation.show_finish_modal" 
:breakpoints="{'960px': '75vw', '640px': '100vw'}" :style="{width: '50vw'}"
:modal="true"
:closable="true"
>




<div class="flex align-items-center justify-content-center mb-6 flex-column">

<h2 class="text-green-400 text-center">{{$store.state.languages.lang_phrases.soru_listesini_tamamlamak_uzeresiniz}}</h2>
<p class="text-center">{{$store.state.languages.lang_phrases.devam_etmeniz_durumunda_isaretlemeleriniz_kaydedilecek_ve_surec_tamamlanacaktir}}</p>
<h3 class="text-green-400">{{$store.state.languages.lang_phrases.devam_etmek_istiyor_musunuz}}</h3>
</div>

<template #footer>
<Button :label="$store.state.languages.lang_phrases.iptal" icon="pi pi-times" @click="close" class=" p-button-danger p-button-outlined  p-button-sm" :loading="$store.state.ui.submitting"/>
<Button :label="$store.state.languages.lang_phrases.devam_et" icon="pi pi-check" @click="submit"  class=" p-button-primary p-button-outlined  p-button-sm"  :loading="submitting"/>
</template>

</Dialog>
</template>

<script>
export default {
  name: 'QuizFinishModal',

  data () {
    return {
    	submitting:false,
    }
  },
  methods:{
  	close()
  	{
  		this.$store.dispatch('evaluation/setShowFinishModal',false) 
  	},
  	submit()
  	{
      this.$store.dispatch('evaluation/setMode',"submitting") 
      console.log(this.$store.state.audit.audit)
      //return false
  		let formdata = new FormData()
      if(this.$store.state.evaluation.evaluation.flow.type=="verification")
      {
        this.generalSubmission(formdata,"audit/finish_verification/"+this.$route.params.id,this.afterSubmit)
      }

      if(this.$store.state.evaluation.evaluation.flow.type=="self_evaluation")
      {
        this.generalSubmission(formdata,"audit/finish_selt_evaluation/"+this.$route.params.id,this.afterSubmit)
      }
      if(this.$store.state.evaluation.evaluation.flow.type=="audit")
      {
        this.generalSubmission(formdata,"audit/finish_audit/"+this.$store.state.audit.audit.flowsupplier.uuid,this.afterSubmit)
        console.log("audit")
      }
  		
  	},
  	async afterSubmit(response)
  	{
  		console.log(response.data)

      if(this.$store.state.evaluation.evaluation.flow.type=="verification")
      {
        console.log("end_verification_session")
        this.$socket.emit('end_verification_session', { flowsupplier_uuid: this.$route.params.id })
      }
  		this.$store.dispatch('evaluation/setShowFinishModal',false) 

      let user = this.$store.state.auth.user
      if(user.userroles && user.userroles.length)
      {
        let userroles = user.userroles.map((element)=>{return element.name})
        if(userroles.includes("admin") )
        {
          this.$router.push({ name: 'SupplierProjects', params: { id:response.data.supplier_id } })
          
        }

        if( userroles.includes("auditor"))
        {
          this.$router.push({ name: 'AuditorAuditSummary', params: { id:response.data.id } })
          
        }
        

      }
  		
  	}
  }
}
</script>

<style lang="css" scoped>
</style>